<template>
  <div class="dropdown"
      :class="{show: isOpen}"
      @click="toggleDropDown"
      v-click-outside="closeDropDown">

    <div class="dropdown-toggle pull-right"
       data-toggle="dropdown">
      <slot name="title">
        <!-- <i :class="icon"></i> -->
        <div class="dropdown-title">{{title}}</div>
        <div class="no-icon dropdown-value">{{selected_value}}</div>
        <!-- <div class="caret"></div> -->
      </slot>
    </div>
    <div class="dropdown-menu dropdown-menu-right" :class="{show: isOpen}" v-show="isOpen">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'drop-down',
    props: {
      title: String,
      selected_value: String,
      icon: String,
      tag: {
        type: String,
        default: 'li'
      }
    },
    data () {
      return {
        isOpen: false
      }
    },
    methods: {
      toggleDropDown () {
        this.isOpen = !this.isOpen
        this.$emit('change', this.isOpen)
      },
      closeDropDown () {
        this.isOpen = false
        this.$emit('change', this.isOpen)
      }
    }
  }
</script>
<style scoped>
  .dropdown .dropdown-toggle{
    cursor: pointer;
  }
</style>
